var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.rental.isBlurred
      ? _c("div", { staticClass: "link-container__greenlist__overlay" }, [
          _c("i", { staticClass: "fa fa-lock" }),
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: _vm.rental.url, title: _vm.rental.title } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("messages_nl.access-denied-rental.title")) +
                  "\n    "
              ),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: [
          "list-item link-container",
          { "list-item__greenlist__hidden": _vm.rental.isBlurred },
        ],
      },
      [
        _c("a", { attrs: { href: _vm.rental.url, title: _vm.rental.title } }, [
          _c(
            "div",
            {
              class: `listing-img-wrapper ${
                _vm.showWatermarkOverlay
                  ? "rental-watermark-overlay-list-image rental-watermark-disable-image-drag"
                  : ""
              }`,
            },
            [
              _vm.showWatermarkOverlay
                ? [
                    _c("i", {
                      staticClass:
                        "fa fa-solid fa-lock rental-watermark-overlay-list-image__icon",
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "rental-watermark-overlay-list-image__paragraph",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("messages_nl.contact.tooltip.premium")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "disable__select__images",
                class: {
                  "no-image": !_vm.rental.image.available,
                  "img-fluid mx-auto": _vm.rental.image.available,
                  "listing-img-hidden": _vm.rental.isBlurred,
                },
                attrs: {
                  src: _vm.rental.image.src,
                  srcset: _vm.rental.image.srcset,
                  sizes: "(max-width: 768px) 100vw, 250px",
                  alt: _vm.rental.title,
                  title: _vm.rental.image.title,
                  width: "250",
                  height: "250",
                  loading: _vm.index === 0 ? "eager" : "lazy",
                  fetchpriority: _vm.index === 0 ? "high" : "auto",
                  referrerpolicy: _vm.rental.useImageHotlinking
                    ? "no-referrer"
                    : false,
                  oncontextmenu: "return false;",
                  draggable: "false",
                },
              }),
              _vm._v(" "),
              [
                _vm.rental.status === _vm.houseStatuses.under_option
                  ? _c(
                      "span",
                      { staticClass: "property-type property--orange" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("messages_nl.rental.status.underOption")
                            ) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm.rental.status === _vm.houseStatuses.rented_out
                  ? _c("span", { staticClass: "property-type property--red" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("messages_nl.rental.status.rented")) +
                          "\n          "
                      ),
                    ])
                  : _vm.rental.isNew
                  ? _c(
                      "span",
                      { staticClass: "property-type property--green" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("messages_nl.rental.status.new")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "listing-content" }, [
          _c("div", { staticClass: "listing-content-top" }, [
            _c("div", { staticClass: "listing-header" }, [
              _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "listing-name",
                    attrs: { href: _vm.rental.url, title: _vm.rental.title },
                  },
                  [
                    _c("h2", { staticClass: "listing-street" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.rental.street) +
                          "\n              "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "listing-location" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.formattedLocation) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "listing-price" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.rental.isBlurred
                        ? _vm.$t(
                            "messages_nl.search.greenlist.placeholders.price"
                          )
                        : _vm.formattedPrice
                    ) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "listing-description",
              domProps: { innerHTML: _vm._s(_vm.truncatedDescription) },
            }),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "listing-footer clean" },
            [
              !_vm.rental.isBlurred
                ? [
                    _c("li", [
                      _vm._m(0),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formattedSpace) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "listing-footer-rooms" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.formattedRooms) +
                            "\n              "
                        ),
                        _vm.rental.rooms !== 0
                          ? _c("span", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("messages_nl.global._room", {
                                      rooms: _vm.rental.rooms,
                                    })
                                  ) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._m(2),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.rental.deliveryLevel) +
                          "\n          "
                      ),
                    ]),
                  ]
                : [
                    _c("li", [
                      _vm._m(3),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "messages_nl.search.greenlist.placeholders.surfaceArea"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "listing-footer-rooms" }, [
                      _vm._m(4),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "messages_nl.search.greenlist.placeholders.rooms"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._m(5),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "messages_nl.search.greenlist.placeholders.deliveryLevel"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ],
            ],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [
      _c("i", { staticClass: "fas fa-ruler-combined mb-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("i", { staticClass: "fas fa-door-open mb-1" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("i", { staticClass: "fas fa-couch mb-1" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [
      _c("i", { staticClass: "fas fa-ruler-combined mb-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("i", { staticClass: "fas fa-door-open mb-1" })])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", [_c("i", { staticClass: "fas fa-home mb-1" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }